export default __webpack_public_path__ + "static/media/kitchen_W112-DIAMANT-EI90.76021031.jpg";